import React from "react";

const ReferIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 30 29"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 25.0249C1 23.6325 1.55312 22.2972 2.53769 21.3126C3.52226 20.328 4.85761 19.7749 6.25 19.7749H16.75C18.1424 19.7749 19.4777 20.328 20.4623 21.3126C21.4469 22.2972 22 23.6325 22 25.0249C22 25.7211 21.7234 26.3888 21.2312 26.8811C20.7389 27.3733 20.0712 27.6499 19.375 27.6499H3.625C2.92881 27.6499 2.26113 27.3733 1.76884 26.8811C1.27656 26.3888 1 25.7211 1 25.0249Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M11.5 14.5249C13.6746 14.5249 15.4375 12.762 15.4375 10.5874C15.4375 8.41278 13.6746 6.6499 11.5 6.6499C9.32538 6.6499 7.5625 8.41278 7.5625 10.5874C7.5625 12.762 9.32538 14.5249 11.5 14.5249Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="23.6836"
      y="0.649902"
      width="1.56083"
      height="10.9258"
      rx="0.780413"
      fill="currentColor"
    />
    <rect
      x="29.9258"
      y="5.33301"
      width="1.56083"
      height="10.9258"
      rx="0.780413"
      transform="rotate(90 29.9258 5.33301)"
      fill="currentColor"
    />
  </svg>
);

export default ReferIcon;
